import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectRoomsInDealFilter } from 'shared/selectors/advancedFilters';

export const RoomsInDealContainer: FC = () => {
  const { label, valueMax, valueMin, max, min } = useSelector(selectRoomsInDealFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setRoomsForSaleMin', arguments: [value] });
  });

  const handleMaxChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setRoomsForSaleMax', arguments: [value] });
  });

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilter width={100}>
        <RangeInput
          min={min}
          max={max}
          valueMin={valueMin}
          valueMax={valueMax}
          onChangeMin={handleMinChange}
          onChangeMax={handleMaxChange}
        />
      </InlineFilter>
    </AdvancedFilterRow>
  );
};
